/**
 * User Preferences module
 *
 * This module provides a service for managing user preferences in both browser storage
 * and a back-end API. The API values take precedence when available, with browser storage
 * acting as a fallback.
 *
 * The module also provides reactive state through Vue's reactivity system for direct access to preferences.
 */

import PreferencesService, { PREFERENCE_KEYS, preferences } from './service.js'

// Export the specific preference key constants for direct use
export const LOCALE = PREFERENCE_KEYS.LOCALE
export const NOTIFICATIONS_SEEN = PREFERENCE_KEYS.NOTIFICATIONS_SEEN
export const INTRO_FEATURES_SEEN = PREFERENCE_KEYS.INTRO_FEATURES_SEEN

// Singleton instance
export default PreferencesService

export {
  preferences,
}
